import icon from 'vue-svgicon';

icon.register({
    'regular/police-man-1': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M17.2 11.25a5.251 5.251 0 0 1-10.394 0M3 23.219a10.516 10.516 0 0 1 9-4.8 10.516 10.516 0 0 1 9 4.8M12 23.25v-4.831M18 6.75a11.867 11.867 0 0 0 1.5-4.5 8.368 8.368 0 0 1-5.766-.633L12 .75l-1.734.867A8.368 8.368 0 0 1 4.5 2.25 11.9 11.9 0 0 0 6 6.75zM6.054 6.75c.364 2.543 3.3 3 5.946 3s5.582-.457 5.946-3z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="1" d="M12 3.75a.375.375 0 1 0 .375.375A.375.375 0 0 0 12 3.75h0M15.75 23.25h1.5" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
